import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'suite-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
